var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useState } from "react";
import * as dateFormat from "./date-format";
// eslint-disable-next-line
const getDateFnsLocale = (localeCode) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        if (localeCode === "en") {
            return yield import(`date-fns/locale/en-US/index.js`);
        }
        return yield import(`date-fns/locale/${localeCode}/index.js`);
    }
    catch (error) {
        // eslint-disable-next-line
        console.warn("Could not load %s locale", localeCode);
        return;
    }
});
const useDateFormat = (localeCode = "en") => {
    const [locale, setLocale] = useState();
    useEffect(() => { var _a; return void ((_a = getDateFnsLocale(localeCode)) === null || _a === void 0 ? void 0 : _a.then(setLocale)); }, [localeCode]);
    const formatDate = useCallback((date, style) => dateFormat.formatDate(date, style, locale), [locale]);
    const formatDateDistance = useCallback((date, dateTo) => dateFormat.formatDateDistance(date, dateTo, locale), [locale]);
    const formatDateDistanceToNow = useCallback((date) => dateFormat.formatDateDistanceToNow(date, locale), [locale]);
    const formatRelativeTimeDistanceFromSeconds = useCallback((fromSeconds) => dateFormat.formatRelativeTimeDistanceFromSeconds(fromSeconds, locale), [locale]);
    return {
        formatDate,
        formatDateDistance,
        formatDateDistanceToNow,
        formatRelativeTimeDistanceFromSeconds,
    };
};
export default useDateFormat;
